import { Circle, Float } from '@chakra-ui/react';
import { ListFilter } from 'lucide-react';
import * as React from 'react';

import { Button, type ButtonProps } from '../button';

export interface FilterTriggerProps extends Omit<ButtonProps, 'leftIcon' | 'rightIcon' | 'variant' | 'colorPalette' | 'size' | 'children'> {
  /** When true, shows an indicator dot signaling active filters. */
  hasActiveFilters?: boolean;
}

export const FilterTrigger = React.forwardRef<HTMLButtonElement, FilterTriggerProps>(function FilterTrigger(props, ref) {
  const { hasActiveFilters, ...rest } = props;

  return (
    <Button
      ref={ref}
      variant="ghost"
      colorPalette="neutral"
      leftIcon={ListFilter}
      size="md"
      position="relative"
      aria-pressed={hasActiveFilters}
      {...rest}
    >
      Filters
      {hasActiveFilters && (
        <Float placement="top-end" offsetX="2" offsetY="3">
          <Circle bg="brand.500" size="8px" />
        </Float>
      )}
    </Button>
  );
});
FilterTrigger.displayName = 'FilterTrigger';
